import { COOKIE_KEYS } from '../constants';
import { useCallback } from 'react';
import { detectBrowserVersion, detectPWA, setCookie } from 'utils';
import { useMutation } from '@tanstack/react-query';
import { accessApp } from 'api';
import { TAccessApp } from 'types';
import { useUserStore } from 'store';

const isPWA = detectPWA();
const browserVersion = detectBrowserVersion();
const browser = browserVersion?.[0]?.toLocaleLowerCase();
const version = +browserVersion?.[1];
// Version available to save cookies when install app
const isValidVersion = browser === 'safari' && version >= 17.2;

function useABTesting() {
  const { clientId, isUserApplyABTesting, setIsUserApplyABTesting } =
    useUserStore();

  const { mutateAsync: mutateAccessApp } = useMutation({
    mutationFn: (body: TAccessApp) => {
      return accessApp(body);
    },
    onSuccess(data) {
      setCookie([
        {
          key: COOKIE_KEYS.APPLY_AB_TESTING,
          value: `${+data?.isApply}`,
        },
      ]);
      if (data?.isApply) {
        setIsUserApplyABTesting(!isPWA);
      }
    },
  });

  const handleAccessApp = useCallback(async () => {
    if (isValidVersion && !isPWA) {
      await mutateAccessApp({
        version: `${browserVersion}`,
        clientId: clientId || '',
      });
    }
  }, [clientId, mutateAccessApp]);

  return { handleAccessApp, isUserApplyABTesting };
}

export default useABTesting;
